var map = {
	"./visualization_lollipop.png": "XtG1",
	"./visualization_polar.png": "AQUM",
	"./visualization_radar.png": "pO6P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oMBz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/visualization_.*\.png$
// module id = oMBz
// module chunks = 94